import { createGlobalStyle } from 'styled-components'
import { reset } from './reset'

export const global = createGlobalStyle`
    ${reset}

    *,
    *:before,
    *:after {
        box-sizing: border-box;
    }

    html {
        background: ${props => props.theme.color.n30};
        box-sizing: border-box;
        font-family: "JD Sans", Arial, Helvetica, sans-serif;
    }

    body {
        position: relative;
        min-height: 100%;
        text-rendering: optimizeLegibility;
    }

    html,
    body {
        height: 100%;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    }

    h1 {
        font-weight: 600;
        font-size: 2.25em;
    }

    h2 {
        font-weight: 600;
        font-size: 1.25em;
        margin: auto;
    }

    h3 {
        text-transform: uppercase;
        font-weight: normal;
        font-size: 1.05em;
        margin-top: 10px;
    }

    h4 {
        font-size: 2em;
        font-weight: normal;
        margin: 0 auto;
        text-transform: uppercase;
        text-align: center;
    }

    h5 {
        font-size: 1.25em;
        font-weight: bolder;
    }

    h6 {
        font-size: 1.25em;
        font-weight: bolder;
    }

    p {
        font-size: 1.05em;
        line-height: 1.65;

        a {
            color: #377539;
            
            :hover, :focus {
                text-decoration: underline;
            }
        }
    }

    ul,
    ol {
        margin: 0;
        padding-left: 20px;
        font-size: 1em;
        line-height: 1.65;

        li {
            margin-bottom: 5px;
        }
    }

    sup {
        font-size: 0.6em;
        top: -0.6em;
    }

    ::selection {
        background-color: #333;
        color: #fff;
    }

    ::placeholder {
        color: #c9c9c9;
        opacity: 0.7;
    }

    .visually-hidden {
        border: 0;
        clip: rect(0 0 0 0);
        height: 1px;
        margin: -1px;
        overflow: hidden;
        padding: 0;
        position: absolute !important;
        width: 1px;
    }

    .display-none {
        display: none !important;
    }

    @media (min-width: 800px) {
        h1 {
            font-size: 3em;
        }

        h2 {
            font-size: 1.5em;
            max-width: none;
        }
    }
`
